export class HaController {

	constructor($scope, JFrogModal, HADao, JFrogGridFactory, $timeout) {
		this.HaDao = HADao;
		this.$timeout = $timeout;
		this.JFrogGridFactory = JFrogGridFactory;
		this.$scope = $scope;
		this.modal = JFrogModal;
		this.gridOptions = {};
		this._createGrid();
		//this.registerEvents();
		this._initHa();
		this.statusDict = {
			0: 'Offline',
			1: 'Online'
		}
	}

	_initHa() {
		this.HaDao.getNodes().$promise.then((response) => {
			this.gridOptions.setGridData(response)
			this.$timeout(() => {
				this.gridOptions.api.grouping.groupColumn('Microservice');
			})

		});

	}

	_createGrid() {
		this.gridOptions = this.JFrogGridFactory.getGridInstance(this.$scope)
		                       .setRowTemplate('default')
		                       .setColumns(this._getColumns())
		                       .setButtons(this._getActions());
	}

	_getColumns() {
		return [
			{
				field: "node_id",
				name: "Node ID",
				displayName: "Node ID",
				allowGrouping: true,
				width: '20%'
			},
			{
				field: "ms_type",
				name: "Microservice",
				displayName: "Microservice",
				cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.ms_type | capitalizeFirst}}</div>`,
				allowGrouping: true,
				width: '20%'
			},
			{
				field: "last_heartbeat",
				name: "Last Time",
				cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.last_heartbeat | date:'medium'}}</div>`,
				displayName: "Last Heartbeat",
				width: '20%'
			},
			{
				field: "version",
				name: "Version",
				displayName: "Version",
				width: '20%',
				cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.version}}</div>`,
			},
			{
				field: "status",
				name: "Status",
				cellTemplate: `<div ng-class="{'online':row.entity.status == 1}" class=" status ui-grid-cell-contents">{{grid.appScope.HaController.statusDict[row.entity.status]}}</div>`,
				displayName: "Status",
				width: '20%',
				customActions: [{
					icon: 'icon icon-clear',
					tooltip: 'Delete Node',
					callback: (row) => {
						this._deleteNode(row);
					},
					visibleWhen: (row) => row.status == 0
				}]
			}
		]
	}

	_deleteNode(node) {
		this.modal.confirm('Are you sure you wish to remove ' + node.node_id + ' from the nodes list?')
		    .then(() => {
			    let params = {};
			    params.node_id = node.node_id;
			    params.ms_type = node.ms_type;
			    //console.log('need to remove node', node)
			    this.HaDao.delete(params).$promise.then(() => this._initHa());
		    })

	}

	_getActions() {
		return [
			{
				icon: 'icon icon-clear',
				tooltip: 'Delete',
				visibleWhen: node => node.heartbeatStale,
				callback: node => this._deleteNode(node)
			}
		];
	}

}


// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/ha/ha.controller.js